
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
	name: 'AlertBox'
})
export default class AlertBox extends Vue {

	/* Props
	============================================*/

	@Prop({ type: String, required: false, default: 'info' })
	readonly type: 'success' | 'info' | 'warning' | 'error';

	@Prop({ type: String, required: false, default: '' })
	readonly message: string;

	get icon() {
		switch (this.type) {
			case 'success':
				return 'checkmark';
			case 'warning':
				return 'alert';
			case 'error':
				return 'alert';
			case 'info':
			default:
				return 'info-tiny';
		}
	}
}

